<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-block-storage-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 45a2 2 0 01-2-2V5a2 2 0 012-2h38a2 2 0 012 2v38a2 2 0 01-2 2H5zM41 7h-4v12a2 2 0 01-2 2H13a2 2 0 01-2-2V7H7v34h4v-9a2 2 0 012-2h22a2 2 0 012 2v9h4V7zM15 34h18v7H15v-7zM33 7H15v10h18V7zm-2 5a3 3 0 10-6 0 3 3 0 006 0z"/></svg>
</template>
<script>

export default {
  name: 'IconBlockStorageAlt',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
